(() => {
  const selector = '[data-featured-collections-carousel]';

  const initialize = (scope = document) => {
    scope.querySelectorAll(selector).forEach((track) => {
      if (track.dataset.carouselInitialized) return;
      track.dataset.carouselInitialized = 'true';
      const cards = [...track.querySelectorAll('.featured-collections__item')];
      const controls = track.parentElement.querySelector('[data-featured-controls]');
      if (!cards.length || !controls) return;
      const previous = controls.querySelector('[data-featured-prev]');
      const next = controls.querySelector('[data-featured-next]');
      const progress = controls.querySelector('[data-featured-progress]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      const options = { signal: abort.signal };
      let frame;

      const positions = () => {
        const origin = cards[0].getBoundingClientRect().left;
        return cards.map((card) => card.getBoundingClientRect().left - origin);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const offsets = positions();
        const visible = cards.map((card, index) => ({ card, index })).filter(({ card, index }) =>
          offsets[index] + card.offsetWidth > track.scrollLeft + 2 &&
          offsets[index] < track.scrollLeft + track.clientWidth - 2
        );
        controls.hidden = max <= 1;
        previous.setAttribute('aria-disabled', String(track.scrollLeft <= 1));
        next.setAttribute('aria-disabled', String(track.scrollLeft >= max - 1));
        if (visible.length) {
          const first = visible[0].index + 1;
          const last = visible[visible.length - 1].index + 1;
          const text = `${first === last ? first : `${first}–${last}`} / ${cards.length}`;
          if (progress.textContent !== text) progress.textContent = text;
        }
      };
      const scrollTo = (left) => track.scrollTo({
        left: Math.max(0, Math.min(left, track.scrollWidth - track.clientWidth)),
        behavior: reducedMotion.matches ? 'instant' : 'smooth'
      });
      const move = (direction) => {
        const offsets = positions();
        const target = direction > 0
          ? offsets.find((offset) => offset > track.scrollLeft + 2)
          : offsets.findLast((offset) => offset < track.scrollLeft - 2);
        if (target !== undefined) scrollTo(target);
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') scrollTo(0);
        else if (event.key === 'End') scrollTo(track.scrollWidth);
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { ...options, passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      const section = track.closest('.shopify-section');
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target !== section) return;
        resize.disconnect();
        cancelAnimationFrame(frame);
        abort.abort();
      }, options);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
